export const customVideo = () => {
    document.addEventListener( 'DOMContentLoaded', () => {

        document.querySelectorAll('.custom-video').forEach(function(customVideoEl){

            if(!customVideoEl.querySelector('video')){
                return false;
            }

            var index_mute = 0;
            customVideoEl.querySelector('[data-action="unmute"]').addEventListener("click", function(event){
                event.preventDefault();
                Array.from(customVideoEl.querySelectorAll("video")).forEach(function(video) {
                    video.muted = false;
                });
                if(window.innerWidth < 768 && index_mute == 0){
                    setTimeout(() => {
                        customVideoEl.querySelector(".mobile-video").play();
                    }, 500);
                }
                this.hidden = true;
                customVideoEl.querySelector('[data-action="mute"]').hidden = false;
                index_mute++;
            });
            customVideoEl.querySelector('[data-action="mute"]').addEventListener("click", function(event){
                event.preventDefault();
                Array.from(customVideoEl.querySelectorAll("video")).forEach((video) => video.muted = true);
                this.hidden = true;
                customVideoEl.querySelector('[data-action="unmute"]').hidden = false;
            })    

            let video_pc = customVideoEl.querySelector(".pc-video");
            let video_sp = customVideoEl.querySelector(".mobile-video");
            let sp_poster = customVideoEl.querySelector(".fit-picture");
            let window_width = window.innerWidth;

            customVideoEl.querySelectorAll(".playpause-button").forEach(function(button) {
                let custom_video = button.closest('.custom-video');
                let video_mobile = custom_video.querySelector(".mobile-only video");
                video_mobile.addEventListener("loadeddata", () => {
                    if ( video_mobile.readyState >= 2) {
                        setTimeout(() => {
                            let Icon_video_play_pause = button.querySelector(".playpause").classList.contains("video-icon-play");
                            let video_play_pause_sp = document.querySelector(".mobile-only video").paused;
                            let data_auto_play = button.closest('.custom-video').getAttribute("data-autoplay");

                            if (Icon_video_play_pause && video_play_pause_sp == true && data_auto_play == "true" && window_width < 768 && video_mobile.currentTime ==  0) {
                                button.querySelector(".video-icon-play").classList.remove("playpause");
                                button.querySelector(".video-icon-pause").classList.add("playpause");
                            }
                        }, 500);
                    }
                });

                video_mobile.onplaying = function() {
                    button.querySelector(".video-icon-pause").classList.remove("playpause");
                    button.querySelector(".video-icon-play").classList.add("playpause");
                };

                button.addEventListener("click", function() {
                    index_mute++;
                    if (button.querySelector(".playpause").classList.contains("video-icon-pause")) {
                        button.querySelector(".video-icon-pause").classList.remove("playpause");
                        button.querySelector(".video-icon-play").classList.add("playpause");
                        video_pc.play();
                        if(video_sp){
                            video_sp.play();
                            sp_poster.style.display = 'none';
                        }
                    }else{
                        button.querySelector(".video-icon-play").classList.remove("playpause");
                        button.querySelector(".video-icon-pause").classList.add("playpause");
                        video_pc.pause();
                        if(video_sp){
                            video_sp.pause();
                        }
                    }
                });
            });
        })

    })
}